import { Pipe, PipeTransform } from '@angular/core';
import { enumDictionary } from './enum-pt-br';

@Pipe({
  name: 'enumText'
})
export class EnumTextPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    if (!enumDictionary[args[0]]) { return 'Enumerador Inválido'; }
    if (!enumDictionary[args[0]][value]) { return (args[0] + ' Inválido'); }

    return enumDictionary[args[0]][value];
  }

}
